import {HttpClient} from '@angular/common/http';
import {Injectable, Optional, SkipSelf} from '@angular/core';
import {
    AcabimAuthRole,
    AcabimSolution,
    ApiService,
    EnvironmentModel,
    PaginatedOrNonPaginatedResponse,
    PaginatedRequest,
    SolutionEnvironmentModel
} from '@cas-hub/acabim-common-client';
import {NGXLogger} from 'ngx-logger';
import {Observable} from 'rxjs';
import {OrganisationPendingUser, OrganisationUser} from '../../_models/organisation/organisation-users.model';

@Injectable({
    providedIn: 'root'
})
export class OrganisationUsersService extends ApiService {
    protected controller = 'api/OrganisationUsers';

    constructor(protected readonly client: HttpClient,
                protected readonly environment: EnvironmentModel,
                @SkipSelf() @Optional() protected solutionEnvironment?: SolutionEnvironmentModel,
                @Optional() protected readonly logger?: NGXLogger) {
        super(client, environment, solutionEnvironment, logger);
        this.serverHost = environment.authority;
    }

    public getUsers(pagination?: PaginatedRequest): Observable<PaginatedOrNonPaginatedResponse<OrganisationUser>> {
        return this.simplePaginatedGet(pagination);
    }

    public getPendingUsers(pagination?: PaginatedRequest): Observable<PaginatedOrNonPaginatedResponse<OrganisationPendingUser>> {
        return this.simplePaginatedGet(pagination, 'pending');
    }

    public changeUserRole(userId: string, role: AcabimAuthRole, attachedSolution?: AcabimSolution): Observable<any> {
        return this.client.put(this.url('role'), {userId, role, attachedSolution}, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }
}
